import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiConfig } from '../../configs/apiConfig';
import { fetchApi } from '../../services/apiService';

const initialState = {
    apiToken: '',
    isLoading: false
}

export const apiAuthenticate = createAsyncThunk(
    'app/ApiAuthenticate',
    async () => {
        const response = await fetchApi('common/apiAuth',apiConfig);
        return response;
    }
);

export const verifyApiToken = createAsyncThunk(
    'app/ApiTokenVerify',
    async (token) => {
        const response = await fetchApi('common/apiTokenAuth',apiConfig,token);
        return response;
    }
);

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(apiAuthenticate.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(apiAuthenticate.fulfilled, (state, action) => {
            state.isLoading = false ;
            const { responseStatus = 'Error'} = action.payload.data;
            const { token: apiToken = ''   } = action.payload.data
            if(responseStatus === 'Ok'){
                localStorage.setItem('apiToken',apiToken);
                state.apiToken = apiToken;    
            }else{
                localStorage.removeItem('apiToken');
                state.apiToken = '';
            }
          }).addCase(verifyApiToken.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(verifyApiToken.fulfilled, (state, action) => {
            state.isLoading = false ;
            const { responseStatus = 'Error'} = action.payload.data;
            const { token: apiToken = ''   } = action.payload.data
            if(responseStatus === 'Ok'){
                localStorage.setItem('apiToken',apiToken);
                state.apiToken = apiToken;    
            }else{
                localStorage.removeItem('apiToken');
                state.apiToken = '';
                //apiAuthenticate(); now working
            }
          });
      },
});

export default appSlice.reducer;